import AdminIndex from '@/pages/admin/Index'

import organization from './organization'
import questions from './questions'
import questionsTest from './questions/test'
import questionsThematic from './questions/thematic'
import questionsPractice from './questions/practice'
import group from './group'
import student from './student'
import attestation from './attestation_info'

export default [
  {
    path: '/admin',
    name: 'AdminIndex',
    component: AdminIndex,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  }
].concat(organization, group, student, attestation, questions, questionsTest, questionsThematic, questionsPractice)



// WEBPACK FOOTER //
// ./src/router/admin/admin.js